import { Component, OnDestroy, OnInit } from '@angular/core';
import { InstitutionService } from 'src/app/services/institution.service';
import Institution from 'src/app/interfaces/Institution';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ProjectService } from 'src/app/services/project.service';
import { UserService } from 'src/app/services/user.service';
import User from 'src/app/interfaces/User';
import { Subscription, BehaviorSubject } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-institutions-single',
  templateUrl: './institutions-single.component.html',
  styleUrls: ['./institutions-single.component.scss'],
})
export class InstitutionsSingleComponent implements OnInit, OnDestroy{
  constructor(
    private institutionService: InstitutionService,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private userService: UserService,
    private toastService: ToastService,
    private analyticsService: AnalyticsService,
    private notificationService: NotificationsService
  ) {}
  institution$;
  institution;
  allMembers = new BehaviorSubject(null);
  activeMembers;
  projects = [];
  subscriptions: Subscription = new Subscription();
  currentUser: User;
  membershipInactive;
  membershipPending;

  ngOnInit() {
    this.analyticsService.event('institution_profile_view');
    this.institution$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) => this.institutionService.getCurrentInstitution(params.get('id')))
    );
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
          this.membershipInactive = this.currentUser.institutions.indexOf(this.institution.id) === -1;
          this.membershipPending =
            this.currentUser.institutionRoles[this.institution.id] &&
            this.currentUser.institutionRoles[this.institution.id].status === 'pending';
        }
      })
    );
    this.institution$.subscribe((p) => {
      this.institution = p[0];

      this.institutionService.getInstitutionMembers(this.institution.id).subscribe((m) => {
        this.allMembers.next(m);
        this.activeMembers = m.filter((m) => m.institutionRoles[this.institution.id].status === 'active');
        this.activeMembers.forEach((m) => {
          if (m.projects) {
            m.projects.forEach((id) => {
              const pSub = this.projectService.getCurrentProject(id).subscribe((p) => {
                if (p && p[0] && !this.projects.some((el) => el.id === p[0].id)) {
                  this.projects.push(p[0]);
                }
                pSub.unsubscribe();
              });
            });
          }
        });
      });
    });
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  addInstitutionToProfile() {
    this.analyticsService.event('institution_profile_add_click');
    if (this.currentUser.institutions.indexOf(this.institution.id) === -1) {
      this.currentUser.institutions.push(this.institution.id);
      this.currentUser.institutionRoles[this.institution.id] = {
        role: 'member',
        status: 'pending',
      };
      this.userService.saveUser(this.currentUser.uid, this.currentUser).then(() => {
        this.institutionService.getInstitutionMembers(this.institution.id).subscribe((m) => {
          this.allMembers.next(m);
          this.institution.allMembers = this.allMembers;
          this.activeMembers = m.filter((m) => m.institutionRoles[this.institution.id].status === 'active');
          this.toastService.setToast(
            '<b>Success!</b> We’ve sent your request to join ' + this.institution.institutionName + '.'
          );
          this.notificationService.sendNotifications({
            type: 'joinInstitution',
            owner: this.institution.owner,
            currentUser: this.currentUser.displayName,
            url: `/institutions/${this.institution.id}`,
          });
          this.notificationService.saveNotification(
            this.institution.owner,
            this.currentUser.uid,
            `requests to join <a href="/institutions/${this.institution.id}">your institution</a>`,
            this.currentUser.displayName,
            this.currentUser.profilePicture
          );
        });
      });
    }
  }
  headingEvent(e) {
    if (e === 'leave') {
      this.removeInstitutionFromProfile();
    }
  }
  removeInstitutionFromProfile() {
    if (this.currentUser.institutions.indexOf(this.institution.id) !== -1) {
      this.currentUser.institutions.splice(this.currentUser.institutions.indexOf(this.institution.id));
      delete this.currentUser.institutionRoles[this.institution.id];
      this.userService.saveUser(this.currentUser.uid, this.currentUser).then(() => {
        this.institutionService.getInstitutionMembers(this.institution.id).subscribe((m) => {
          this.allMembers.next(m);
          this.institution.allMembers = this.allMembers;
          this.activeMembers = m.filter((m) => m.institutionRoles[this.institution.id].status === 'active');
          this.toastService.setToast('Successfully left ' + this.institution.institutionName);
        });
      });
    }
  }
}
